
// auth
export const LOGIN_USER = "LOGIN_USER"
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"

// register
export const REGISTER_USER = "REGISTER_USER"
export const REGISTER_SUCCESS = "REGISTER_SUCCESS"

// invoice actions
export const TOGGLE_MODAL = 'TOGGLE_MODAL';
export const SET_ERRORS = 'SET_ERRORS';

// user
export const GET_USER = "GET_USER";
export const GET_USERS = "GET_USERS";
export const GET_USERS_SUCCESS = "GET_USERS_SUCCESS";
export const UPDATE_USER = "UPDATE_USER";
export const DELETE_USER = "DELETE_USER";
export const DISABLE_USER = "DISABLE_USER";
export const ENABLE_USER = "ENABLE_USER";
export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const RESET_PASSWORD = "RESET_PASSWORD";
